/**
 * React 19 兼容性配置
 * 为 antd-mobile 设置自定义渲染方法以支持 React 19
 */

import { unstableSetRender } from 'antd-mobile';
import { createRoot } from 'react-dom/client';

// React 19 容器类型扩展
interface ContainerElement extends Element {
  _reactRoot?: ReturnType<typeof createRoot>;
}

/**
 * 配置 React 19 渲染器
 * 解决 antd-mobile 与 React 19 的兼容性问题
 */
export function setupReact19Compatibility(): void {
  unstableSetRender((node, container) => {
    const cont = container as ContainerElement;

    // 如果容器还没有 React Root，创建一个
    cont._reactRoot ||= createRoot(container);

    const root = cont._reactRoot as ReturnType<typeof createRoot>;

    // 渲染节点
    root.render(node);

    // 返回卸载函数
    return async () => {
      await new Promise((resolve) => setTimeout(resolve, 0));
      root.unmount();
    };
  });
}
